import CancelIcon from '@/assets/icons/button/cancel.svg';
import DeleteIcon from '@/assets/icons/button/delete.svg';
import DeleteItemIcon from '@/assets/icons/button/delete-item.svg';
import DeleteSimpleIcon from '@/assets/icons/button/delete-simple.svg';
import SaveIcon from '@/assets/icons/button/save.svg';
import AddIcon from '@/assets/icons/button/add.svg';
import CopyIcon from '@/assets/icons/button/copy.svg';
import RefreshIcon from '@/assets/icons/button/refresh.svg';
import RepeatIcon from '@/assets/icons/button/repeat.svg';
import EditIcon from '@/assets/icons/button/edit.svg';
import AIIcon from '@/assets/icons/button/ai.svg';
import CloseIcon from '@/assets/icons/button/close.svg';
import SendIcon from '@/assets/icons/button/send.svg';
import EditSquareIcon from '@/assets/icons/button/edit-square.svg';
import ClipIcon from '@/assets/icons/button/clip.svg';

export {
  CancelIcon,
  DeleteIcon,
  DeleteItemIcon,
  DeleteSimpleIcon,
  SaveIcon,
  AddIcon,
  CopyIcon,
  RefreshIcon,
  RepeatIcon,
  EditIcon,
  AIIcon,
  CloseIcon,
  SendIcon,
  EditSquareIcon,
  ClipIcon,
};
